var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4515 6.83333C11.4515 8.21405 10.3322 9.33333 8.95146 9.33333C7.57074 9.33333 6.45146 8.21405 6.45146 6.83333C6.45146 5.45262 7.57074 4.33333 8.95146 4.33333C10.3322 4.33333 11.4515 5.45262 11.4515 6.83333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.83331C2.0619 3.4524 5.22046 1 8.95182 1C12.6832 1 15.8418 3.45243 16.9037 6.83336C15.8418 10.2143 12.6832 12.6667 8.95184 12.6667C5.22046 12.6667 2.06188 10.2142 1 6.83331Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.8d73257d2cc052fa2e0ed21cdeac1815.svg";
export { ForwardRef as ReactComponent };